export const commonEn: Record<string, string> = {
  "hud.mana": "ENERGY (LIFE)",
  "hud.tempo": "TEMPO",
  "hud.blessing": "POWER",
  "hud.pressSpace": "Press Space to begin",
  "hud.chapelCost": "Tower: {{cost}} energy",
  "hud.wallCost": "Wall: {{cost}} energy",
  "hud.amplifierCost": "Amp: {{cost}} energy",
  "hud.trapCost": "Trap: {{cost}} energy",
  "hud.modeAmp": "Amplifier",
  "hud.modeTrap": "Trap",
  "hud.relicCost": "Gem: {{cost}} energy",
  "hud.shrineCost": "Shrine: {{cost}} energy",
  "hud.modeShrine": "Shrine",
  "hud.modeLabel": "Mode [W/A/T/R]:",
  "hud.modeTower": "Tower",
  "hud.modeWall": "Wall",
  "hud.horde": "WAVE",
  "hud.spawned": "{{spawned}}/{{total}} spawned",
  "hud.next": "Next:",
  "hud.mobType.Normal": "Standard",
  "hud.mobType.Swarm": "Swarm",
  "hud.mobType.Armored": "Armored",
  "hud.mobType.Giant": "Giant",
  "hud.mobType.Runner": "Runner",
  "hud.nextDetails": "{{count}}× HP {{hp}}",
  "hud.hint.clickGround": "Click ground: build tower",
  "hud.hint.keys": "Keys 1-8: create gem",
  "hud.hint.clickChapel": "Click tower: install gem",
  "hud.hint.sanctify": "U: upgrade  D: duplicate  C: combine",
  "hud.hint.meltdown": "X: melt down  Space: begin wave",
  "hud.inventory": "Gems:",
  "hud.noRelics": "No gems (press 1-8 to create)",
  "hud.hint.bomb": "Drag gem onto field - AoE bomb",
  "hud.settings": "Settings",
  "battleMenu.title": "Settings",
  "battleMenu.audioOn": "Sound: on",
  "battleMenu.audioOff": "Sound: off",
  "battleMenu.resume": "Resume battle",
  "battleMenu.restart": "Restart battle",
  "battleMenu.exit": "Exit to map",
  "hud.priest": "Player Lv {{level}}",
  "hud.grace": "Score {{grace}}",
  "hud.buildings": "BUILDINGS",
  "hud.buildingsHidden": "{{n}} hidden",
  "hud.relics": "GEMS",
  "hud.relicsCount": "{{filled}} / {{total}}",
  "hud.actions": "ACTIONS",
  "hud.actionsHint": "hold [U/D/X]",
  "hud.actionCreate": "Create",
  "hud.actionDual": "Dual",
  "hud.actionCombine": "Combine",
  "hud.actionSanctify": "Upgrade",
  "hud.actionBomb": "Bomb",
  "hud.actionMelt": "Melt",
  "hud.actionRandom": "Random",
  "hud.speed0Title": "Paused (0x)",
  "hud.speed1Title": "Normal (1x)",
  "hud.speed3Title": "Fast (3x)",
  "hud.waveCallNext": "Wave {{n}} - call next now",
  "hud.waveDone": "Wave {{n}} - finished",
  "hud.waveLocked": "Wave {{n}} — not yet",
  "hud.waveLabel": "WAVE",
  "hud.waveTitle": "WAVE {{index}}",
  "hud.waveSpawned": "{{spawned}}/{{total}} spawned",
  "hud.nextTitle": "NEXT",
  "hud.nextWaveDetails": "{{mobType}} · {{count}}× HP {{hp}}",
  "hud.topbarWave": "W{{index}} · {{spawned}}/{{total}}",
  "hud.topbarNext": "Next: {{mobType}}",
  "hud.prepSpace": "Space or Wave 1 - begin defense",
  "hud.buildChapel": "Tower",
  "hud.buildWall": "Wall",
  "hud.buildAmplifier": "Amplifier",
  "hud.buildTrap": "Trap",
  "hud.buildShrine": "Shrine",
  "hud.createGemHint": "Press 1-8 to pick a color",
  "hud.upgradeCost": "Upgrade cost: {{cost}}",
  "hud.damage": "Damage: {{min}} - {{max}}",
  "hud.range": "Range: {{range}}",
  "hud.fireRate": "Rate: {{rate}}/s",
  "map.title": "Tower Defense Engine",
  "map.priestLv": "Player Lv {{level}}",
  "map.xpProgress": "{{xp}} / {{next}} XP",
  "map.worldMap": "World Map",
  "map.launchCta": "Start Test",
  "map.startDefense": "Start test",
  "settings.title": "Defense Settings — {{field}}",
  "settings.hordeHp": "Enemy HP",
  "settings.extraHordes": "Extra Waves",
  "settings.trials": "Modifiers",
  "settings.resilientHorrors": "Resilient enemies (x2.63 leak)",
  "settings.unholyVigor": "Enemy recovery (+50% HP on return)",
  "settings.graceMult": "Score multiplier: x{{mult}}",
  "settings.begin": "Begin Test",
  "settings.retreat": "Retreat [Esc]",
  "result.sanctified": "VICTORY!",
  "result.fallen": "DEFEAT",
  "result.clickRetreat": "Click to retreat",
  "story.clickToContinue": "Click to continue...",
  "story.intro.panel1": "This is the base ruleset: place towers, socket gems, and stop enemies before they reach the core.",
  "story.intro.panel2": "The engine does not care what world uses it. Campaigns provide names, maps, story, and art.",
  "story.intro.panel3": "Use this sandbox to verify mechanics before a campaign skin takes over.",
  "story.hollow_one.panel1": "Base engine checkpoint reached.",
  "summary.title.win": "VICTORY!",
  "summary.title.lose": "DEFEAT",
  "summary.kills": "Kills",
  "summary.banishes": "Breached",
  "summary.bombs": "Bombs cast",
  "summary.earlyCalls": "Early spawn calls",
  "summary.earlyLight": "Energy from early spawns",
  "summary.duration": "Duration",
  "summary.xpEarned": "Score earned",
  "summary.retreat": "Click to return to map",
  "skills.title": "Upgrades",
  "skills.grace": "Free: {{n}} / {{total}}",
  "skills.button": "Skills [S]",
  "skills.lvMax": "Lv {{lv}}/{{max}}",
  "skills.val": "val: {{v}}",
  "skills.needLevel": "Lv{{req}} req",
  "skills.needPoints": "need {{cost}}pt",
  "skills.maxed": "MAX",
  "skills.costShort": "cost: {{cost}}",
  "skills.addTitle": "Add one level (Shift: add as many as possible)",
  "skills.refundTitle": "Refund one level (Shift: refund all)",
  "skill.0": "Initial resource",
  "skill.1": "Resource flow",
  "skill.2": "Leak recovery cost",
  "skill.3": "Unit assembly cost",
  "skill.4": "Structure cost",
  "skill.5": "Structure refund",
  "skill.6": "Green effect power",
  "skill.7": "Red effect power",
  "skill.8": "Burst damage",
  "skill.9": "Orange effect power",
  "skill.10": "Lime effect power",
  "skill.11": "Booster power",
  "skill.12": "Resource capacity",
  "skill.13": "Dual unit efficiency",
  "skill.14": "High-grade starter chance",
  "skill.15": "Purple effect power",
  "skill.16": "Blue effect power",
  "skill.17": "Charge node power",
  "skill.18": "Cyan effect power",
  "skill.19": "Yellow effect power",
  "skill.20": "Lane module power",
  "skill.21": "Projectile damage",
  "skill.22": "Starter unit grade",
  "skill.23": "Deployment time",
  "skill.24": "Firing speed",
  "skill.25": "Range",
  "skill.26": "Map marks to resource",
  "skill.desc.0": "Begin each run with more resource and a larger resource cap.",
  "skill.desc.1": "Increase passive resource recovery and resource gained from defeated enemies.",
  "skill.desc.2": "Reduce the resource cost to recover from an enemy leak.",
  "skill.desc.3": "Reduce resource spent to create and combine attack units.",
  "skill.desc.4": "Reduce resource spent to place defensive structures and support modules.",
  "skill.desc.5": "Increase resource refunded when a structure is dismantled.",
  "skill.desc.6": "Strengthen the green damage-over-time effect.",
  "skill.desc.7": "Strengthen the red critical-hit effect.",
  "skill.desc.8": "Increase area burst damage from detonations and splash hits.",
  "skill.desc.9": "Strengthen the orange multi-target effect.",
  "skill.desc.10": "Strengthen the lime chain-hit effect.",
  "skill.desc.11": "Increase support power from adjacent booster structures.",
  "skill.desc.12": "Improve maximum resource capacity and related unlocks.",
  "skill.desc.13": "Improve dual-color unit efficiency and retained effect strength.",
  "skill.desc.14": "Increase the chance that newly created units start at a higher grade.",
  "skill.desc.15": "Strengthen the purple slow effect.",
  "skill.desc.16": "Strengthen the blue armor-reduction effect.",
  "skill.desc.17": "Increase stored-charge damage from special nodes.",
  "skill.desc.18": "Strengthen the cyan shock effect.",
  "skill.desc.19": "Strengthen the yellow resource-on-hit effect.",
  "skill.desc.20": "Increase damage and carried effect strength for lane modules.",
  "skill.desc.21": "Increase direct projectile damage for all attack units.",
  "skill.desc.22": "Improve the grade of the first random attack unit on a field.",
  "skill.desc.23": "Reduce the delay for placing, moving, or swapping attack units.",
  "skill.desc.24": "Reduce the interval between attacks.",
  "skill.desc.25": "Increase attack range.",
  "skill.desc.26": "Convert completed-map marks into bonus starting resource.",
  "gem.name.Yellow": "Energy",
  "gem.name.Orange": "Blast",
  "gem.name.Red": "Crit",
  "gem.name.Purple": "Slow",
  "gem.name.Green": "Poison",
  "gem.name.Blue": "Armor",
  "gem.name.Cyan": "Shock",
  "gem.name.Lime": "Chain",
  "gem.level": "Grade {{lvl}}",
  "gem.effect.Yellow": "Energy: +0.3×lvl mana per hit",
  "gem.effect.Orange": "Blast: 14% chance — full dmg to all nearby (radius 1 cell)",
  "gem.effect.Red": "Crit: 18% chance — ×2 damage",
  "gem.effect.Purple": "Slow: −30% speed for 2 sec",
  "gem.effect.Green": "Poison: 8×lvl dmg/sec for 2.5 sec",
  "gem.effect.Blue": "Armor: −0.18×lvl armor permanently",
  "gem.effect.Cyan": "Shock: 17% chance — stun for 1.5 sec",
  "gem.effect.Lime": "Chain: 25% chance — hit 2nd target at 60% dmg",
  "gem.effectDetail.Yellow": "Mana +{{mana}}",
  "gem.effectDetail.Orange": "Chance {{chance}} · Radius {{radius}}",
  "gem.effectDetail.Red": "Chance {{chance}} · Damage x{{mult}}",
  "gem.effectDetail.Purple": "Slow {{slow}} · {{duration}}",
  "gem.effectDetail.Green": "Poison {{dps}}/s · {{duration}}",
  "gem.effectDetail.Blue": "Armor -{{armor}}",
  "gem.effectDetail.Cyan": "Chance {{chance}} · {{duration}}",
  "gem.effectDetail.Lime": "Chance {{chance}} · Damage {{damage}}",
  "stats.title": "Mage Stats",
  "stats.button": "Stats [I]",
  "stats.summaryHeader": "Summary",
  "stats.timePlayed": "Time played",
  "stats.battles": "Battles",
  "stats.wins": "Wins",
  "stats.losses": "Losses",
  "stats.winRate": "Win rate",
  "stats.killsHeader": "Slayer",
  "stats.totalKills": "Enemies destroyed",
  "stats.totalBanishes": "Enemies breached",
  "stats.earlyHurryHeader": "Early horde calls",
  "stats.manaFromEarlyWaves": "Energy from early spawns (career)",
  "stats.earlyWaveHurries": "Early spawn calls (career)",
  "stats.fieldsHeader": "Top maps",
  "stats.colField": "Field",
  "stats.colWins": "W",
  "stats.colFails": "L",
  "stats.colXp": "Best XP",
  "tutorial.step1": "Click empty ground to build a tower",
  "tutorial.step2": "Press 1-8 to create a gem",
  "tutorial.step3": "Click the tower to install the gem",
  "tutorial.step4": "Press Space to begin the wave",
  "tutorial.step5": "Right-click to demolish (50% refund)",
  "tutorial.next": "Next →",
  "tutorial.skip": "Skip",
  "tutorial.firstGem": "Create a gem first and place it into a tower",
  "stats.achievementsHeader": "Achievements",
  "stats.achievementsUnlocked": "{{n}} / {{total}} unlocked",
  "achievement.first_blood.name": "First Blood",
  "achievement.first_blood.desc": "Destroy your first enemy",
  "achievement.first_victory.name": "First Victory",
  "achievement.first_victory.desc": "Win your first battle",
  "achievement.slayer_100.name": "Slayer I",
  "achievement.slayer_100.desc": "Destroy 100 enemies",
  "achievement.slayer_1000.name": "Slayer II",
  "achievement.slayer_1000.desc": "Destroy 1000 enemies",
  "achievement.banisher_100.name": "Banisher",
  "achievement.banisher_100.desc": "Let 100 enemies breach the core",
  "achievement.battles_10.name": "Veteran",
  "achievement.battles_10.desc": "Start 10 battles",
  "achievement.battles_50.name": "Champion",
  "achievement.battles_50.desc": "Start 50 battles",
  "achievement.played_1h.name": "Dedicated",
  "achievement.played_1h.desc": "Play for 1 hour total",
  "achievement.fields_5.name": "Explorer",
  "achievement.fields_5.desc": "Complete 5 different maps",
  "achievement.fields_20.name": "Conqueror",
  "achievement.fields_20.desc": "Complete 20 different maps",
  "achievement.priest_level_5.name": "Adept",
  "achievement.priest_level_5.desc": "Reach player level 5",
  "achievement.priest_level_10.name": "Master",
  "achievement.priest_level_10.desc": "Reach player level 10",
  "achievement.early_wave_light_100.name": "Bold timing I",
  "achievement.early_wave_light_100.desc": "Gather 100 energy from early wave spawns (career)",
  "achievement.early_wave_light_2000.name": "Bold timing II",
  "achievement.early_wave_light_2000.desc": "Gather 2,000 energy from early wave spawns (career)",
  "achievement.early_wave_light_50000.name": "Bold timing III",
  "achievement.early_wave_light_50000.desc": "Gather 50,000 energy from early wave spawns (career)",
  "achievement.early_wave_light_100000.name": "Bold timing IV",
  "achievement.early_wave_light_100000.desc": "Gather 100,000 energy from early wave spawns (career)",
  "achievement.early_wave_calls_500.name": "Relentless herald",
  "achievement.early_wave_calls_500.desc": "Call 500 early spawns (career)",
  "hud.fieldLocked": "Field is locked",
  "hud.fieldLockedHint": "Win an adjacent field first",
  "toast.levelUp": "Level {{level}}!",
  "toast.levelUpSubtitle": "Your power grows",
  "toast.giftsUnlocked": "New gifts unlocked",
  "toast.giftUnlockedSubtitle": "{{name}} - {{points}} points available",
  "toast.giftsUnlockedSubtitle": "{{count}} new upgrades - {{points}} points available",
  "toast.giftsAvailable": "Points available",
  "toast.giftsAvailableSubtitle": "{{points}} point(s) to spend",
  "toast.earlyWaveManaTitle": "+{{n}} energy",
  "toast.earlyWaveManaSubtitle": "Early wave call",
  "locale.toggle": "EN",
  "mobile.rotateDevice": "Please rotate your device",
  "summary.xp": "Score gained",
};
